import { useTranslation } from 'react-i18next'
import Button from '@/components/ui/Button'

export default function StaleBundleNotice() {
  const { t } = useTranslation()

  return (
    <div className="flex h-page items-center justify-center bg-(--color-surface)">
      <div className="mx-auto max-w-md px-4 text-center">
        <h1 className="mb-2 text-heading-xl font-bold">
          {t('errors.staleBundle.title')}
        </h1>
        <p className="mb-6 text-muted-foreground">
          {t('errors.staleBundle.body')}
        </p>
        <Button variant="primary" onClick={() => window.location.reload()}>
          {t('errors.staleBundle.reload')}
        </Button>
      </div>
    </div>
  )
}
